<p-accordion [multiple]="false">
    <p-accordionTab header="Account Posting Type (required for sending to QuickBooks)">
        <ef-posting-account-container
            [accounts]="accounts"
            [selectedError]="selectedError"
            (ShowError)="ShowError.next($event)"
        ></ef-posting-account-container>
        <ng-template pTemplate="content"></ng-template>
    </p-accordionTab>
    <p-accordionTab *ngIf="arAccounts?.length > 1" header="Assign Accounts Receivable by Contract">
        <ef-accounts-receivable-contract-container
            [accounts]="arAccounts"
            [contracts]="contracts"
            [selectedError]="selectedError"
            (ShowError)="ShowError.next($event)"
        >
        </ef-accounts-receivable-contract-container>
        <ng-template pTemplate="content"></ng-template>
    </p-accordionTab>
    <p-accordionTab [selected]="true" class="default-expansion" header="Account Allocation">
        <ef-cost-allocation-container
            [selectedError]="selectedError"
            (ShowError)="ShowError.next($event)"
            (HasFacilityExpense)="onHasFacilityExpense($event)"
        ></ef-cost-allocation-container>
    </p-accordionTab>
    <p-accordionTab *ngIf="showFacilityAllocation" header="Facility Allocation">
        <ef-facility-container
            [selectedError]="selectedError"
            (ShowError)="ShowError.next($event)"
        >
        </ef-facility-container>
    </p-accordionTab>
</p-accordion>
